import React from 'react';
import { Button, Row, Col, Tab, Tabs} from 'react-bootstrap';
import config, { hubAccessLevels } from '../../constant/config';
import HomeTab from '../common/HomeTab';
import UsersTab from '../common/UsersTab';
import checkStatus from '../common/checkStatus';
import CreateModule from '../common/CreateModuleContainer';
import CreatePlanSession from '../common/CreatePlanSessionContainer';
import ModulesTab from '../common/ModulesTab';
import FoldersTab from '../common/FoldersTab';
import AnalyticsTab from '../common/AnalyticsTab';
import SettingsTab from '../common/SettingsTab';
import Error404 from '../common/Error404';
import './HubHome.css';
import { FaCheckCircle} from 'react-icons/fa';
import { IconContext } from "react-icons";
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';
import { Create } from '../common/Create';
import { ViewGroup } from '../common/ViewGroup';
import CoursesTab from '../common/CoursesTab';
import Filter from '../common/Filter';

class HubHome extends React.Component {
  constructor(props) {
    super(props);
  //    const locationState = props.location && props.location.state;
  // const activeTab = locationState && typeof locationState.activeTab !== 'undefined'
  //   ? locationState.activeTab
  //   : 0;
  let activeTab = 0;
    if (props.location && props.location.state && props.location.state.activeTab) {
      activeTab = props.location.state.activeTab;
    }
    this.state = {
      hub: null,
      activeTab: activeTab,
      modules: [],
      plans: [],
      featuredModules: [],
      featuredFolders: [],
      followersCount: 0,
      notfound: false,
      siteOwnerHublevel: null,
      hubPathname: this.props.match.params,
      isExpanded1: true,
      isExpanded2: true,
      isExpanded3: true,
      bookmarks: [],
      tagList:[],
      draftCourses: [],
      publishedCourses: [],
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.changeToSettingsTab = this.changeToSettingsTab.bind(this);
    this.getCourseDetails = this.getCourseDetails.bind(this);
  }

  componentDidMount() {
    this.getHub();
    if(this.props.user){
    this.getBookmarks();
    }

    if(this.state.activeTab == 0)
      this.props.toggleSideBar(80)
    sessionStorage.setItem("lastPage", window.location.pathname);
  }

  async onFollowHub(e) {
    e.preventDefault();
    try {
      const res = await fetch(`${config.apiURL}/hub/${this.state.hub.id}/follow`, {
        credentials: 'include',
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status !== 200) {
        throw new Error('unable to follow hub');
      }
      const newHub = await res.json();
      this.props.onFollowHub(newHub);
      this.getHub();
    } catch (err) {
      console.error(err.message);
    }
  }

  async onUnfollowHub(e) {
    e.preventDefault();
    try {
      const res = await fetch(`${config.apiURL}/hub/${this.state.hub.id}/user`, {
        credentials: 'include',
        method: 'DELETE',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          id: this.props.user.id,
        }),
      });
      if (res.status !== 200) {
        throw new Error('unable to unfollow hub');
      }
      this.props.onUnfollowHub(this.state.hub.id);
      this.getHub();
    } catch (err) {
      console.error(err.message);
    }
  }

  async onLeaveHub(e) {
    e.preventDefault();
    try {
      const res = await fetch(`${config.apiURL}/hub/${this.state.hub.id}/user`, {
        credentials: 'include',
        method: 'DELETE',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          id: this.props.user.id,
        }),
      });
      if (res.status !== 200) {
        throw new Error('unable to follow hub');
      }
      this.getHub();
    } catch (err) {
      console.error(err.message);
    }
  }

  onLogoClick = () => {
    this.setState({ activeTab: 0 });
  }

  async getModules(hubid) {
    try {
      const res = await fetch(`${config.apiURL}/hub/${hubid}/modules`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const data = await res.json();
        this.setState({ modules: data.modules, tagList: data.tagList});
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getBookmarks(){
    const res = await fetch(`${config.apiURL}/user/bookmarks`, {
          method: 'GET',
          credentials: 'include',
          headers: { 'content-type': 'application/json' },
        });
        const bookmarks = await res.json();
        this.setState({ bookmarks });
  }

  async getFeaturedModules(hubId) {
    try {
      const res = await fetch(`${config.apiURL}/hub/${hubId}/modules/featured`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const featuredModules = await res.json();
        await this.setState({ featuredModules: featuredModules });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getFeaturedFolders(hubId) {
    try {
      const res = await fetch(`${config.apiURL}/hub/${hubId}/plans/featured`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const featuredFolders = await res.json();
        await this.setState({ featuredFolders: featuredFolders });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getFollowers(hubId) {
    try {
      const res = await fetch(`${config.apiURL}/hub/${hubId}/followers`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const hub = await res.json();
        await this.setState({ followersCount: hub.followerCount });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getHub() {
    const { pathname } = this.state.hubPathname;
    try {
      const res = await fetch(`${config.apiURL}/hub/name/${pathname}/`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const hub = await res.json();
        await this.getModules(hub.id);
        await this.getFeaturedModules(hub.id);
        await this.getFeaturedFolders(hub.id);
        await this.getFollowers(hub.id);
        await this.setState({ hub });
        await this.getPlans();
        if (hub.userAccessLevel === hubAccessLevels.SITE_OWNER) {
          this.getSiteOwnerActionButtonLevel();
        }
        if((hub.id != null && hub.id != undefined ) && this.props.user){
                await this.getCourseDetails();
        }
      } else {
        throw new Error('not found');
      }
    } catch (err) {
      this.setState({ notfound: true });
    }
  }

  async getPlans() {
    try {
      const res = await fetch(`${config.apiURL}/hub/${this.state.hub.id}/plans`, {
        method: 'GET',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const plans = await res.json();
        this.setState({ plans });
      }
    } catch (err) {
      console.error(err.message);
    }
  }

  async getCourseDetails() {
    try{
const res = await fetch(`${config.apiURL}/hub/${this.state.hub.id}/getAllCourseDetails?userId=${encodeURIComponent(this.props.user.id)}`, {
              method: 'GET',
              credentials: 'include',
              headers: { 'content-type': 'application/json' },
            });
            if (res.status == 200) {
              const coursesInHub = await res.json(); 
              const draftCourses = coursesInHub.filter(course => course.isDraft).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
              const publishedCourses = coursesInHub.filter(course => !course.isDraft);
              this.setState({
                draftCourses,
                publishedCourses,
              });         
            } 
            }  catch(err){
              console.log(err);
            }
  }


  getTabs() {
    let tabs = [
      {
        title: 'Home',
        component: () => <HomeTab modules={this.state.modules} hub={this.state.hub} plans={this.state.plans} featuredModules={this.state.featuredModules} changeToSettingsTab={this.changeToSettingsTab} changeTab={this.handleSelect} user={this.props.user} bookmarks={this.state.bookmarks} tagList={this.state.tagList}/>,
      },
      {
        title: 'Folders',
        component: () => <FoldersTab plans={this.state.plans} hub={this.state.hub} changeTab={this.handleSelect} user={this.props.user} featuredFolders={this.state.featuredFolders} changeToSettingsTab={this.changeToSettingsTab} />,
      },
      {
        title: 'Forums',
        component: () => <ModulesTab modules={this.state.modules} hub={this.state.hub} changeTab={this.handleSelect} user={this.props.user} bookmarks={this.state.bookmarks} tagList={this.state.tagList} forumTabFlag={true} />,
      },
    ];

    if(this.state.hub.has_elearning && this.state.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN ){
       tabs = [...tabs,
      {
        title: 'Quizzes',
        component: () => <ModulesTab modules={this.state.modules} hub={this.state.hub} changeTab={this.handleSelect} user={this.props.user} bookmarks={this.state.bookmarks} tagList={this.state.tagList}/>,
      },
    ]
    }
    if(this.state.hub.has_elearning && this.props.user){
      tabs = [...tabs,{
        title: 'Courses',
        component: () => <CoursesTab plans={this.state.plans} hub={this.state.hub} changeTab={this.handleSelect} user={this.props.user} draftCourses={this.state.draftCourses} publishedCourses={this.state.publishedCourses}/>,
      },
    ]
  }
     if (this.state.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) {
      tabs = [...tabs,
        { title: 'Create', component: () => <Create hubId={this.state.hub.id} approved={this.state.hub.approved} user={this.props.user} modules={this.state.modules} users={this.state.hub.users} history={this.props.history} 


        location={this.props.location} elearningApproved={this.state.hub.has_elearning} filtersApproved={this.state.hub.active_filter} changeTab={this.handleSelect} getCourseDetails={this.getCourseDetails}></Create>},
      ];
    }
    if(this.state.hub.active_filter && (this.state.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN)){
      tabs = [...tabs,{
        title: 'Filter',
        component: () => <Filter  hubId={this.state.hub.id} changeTab={this.handleSelect} />,
      }
    ]
  }
    if (this.props.user) {
      tabs = [...tabs, { title: 'Hub Users', component: () => <UsersTab accessLevel={this.state.hub.userAccessLevel} hubId={this.state.hub.id} users={this.state.hub.users} modules={this.state.modules} elearningApproved={this.state.hub.has_elearning}/> }];
    }
    if((this.state.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) && this.state.hub.has_elearning)
      {
        tabs=[...tabs, 
          { title: 'Groups', component: () => <ViewGroup hubId={this.state.hub.id} approved={this.state.hub.approved} user={this.props.user} modules={this.state.modules} users={this.state.hub.users} history={this.props.history} 
          location={this.props.location}></ViewGroup>},
        ]
      }
    // if (this.state.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) {
    //   tabs = [...tabs,
        
    //             { title: 'Analytics', component: () => <AnalyticsTab hubId={this.state.hub.id} /> },
    //   ];
    // }

    if (this.state.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) {
      tabs = [...tabs,
        { title: 'Settings', component: () => <SettingsTab editHub={editedHub => this.saveHubChanges(editedHub)} hub={this.state.hub} plans={this.state.plans} modules={this.state.modules} featured={this.state.featuredModules} featuredFolders={this.state.featuredFolders}/> },
      ];
    }

    return tabs;
  }

  async getSiteOwnerActionButtonLevel() {
    try {
      const res = await fetch(`${config.apiURL}/siteowner/${this.state.hub.id}/hublevel`, {
        method: 'GET',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const accessLevel = await res.json();
        this.setState({
          siteOwnerHublevel: accessLevel,
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  getHubWebsiteURL(url) {
    const httpPrefix = 'http';
    if (url.substr(0, httpPrefix.length) !== httpPrefix) {
      const prefixedURL = `${httpPrefix}://${url}`;
      return prefixedURL;
    }
    return url;
  }

  async saveHubChanges(editedHub) {
    try {
      const res = await fetch(`${config.apiURL}/hub/${editedHub.id}`, {
        credentials: 'include',
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          id: editedHub.id,
          name: editedHub.name,
          organisation: editedHub.organisation,
          phoneNumber: editedHub.phoneNumber,
          website: editedHub.website,
          address1: editedHub.address1,
          address2: editedHub.address2,
          postcode: editedHub.postcode,
          description: editedHub.description,
          activities: editedHub.activities,
          targetGroups: editedHub.targetGroups,
          goals: editedHub.goals,
          logoId: editedHub.logoId,
          bannerId: editedHub.bannerId,
          twitter: editedHub.twitter,
          facebook: editedHub.facebook,
          googlePlus: editedHub.googlePlus,
          linkedin: editedHub.linkedin,
          featured: editedHub.featured,
          featuredFolders: editedHub.featuredFolders,
          location: editedHub.location,
          targetConfidence: editedHub.targetConfidence,
          target: editedHub.target,
          physicalActivity: editedHub.physicalActivity,
          showFollowers: editedHub.showFollowers,
          showContactInfo: editedHub.showContactInfo
        }),
      });
      if (res.status === 200) {
        this.setState({activeTab:0});
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
    }
  }

  async handleSelect(key) {
    if (this.state.activeTab !== 0 && key === 0) {
      await this.getHub();
      this.props.toggleSideBar(80)
    }
    await this.setState({ activeTab: key });
  }

  async changeToSettingsTab ()  {
    const tabs = this.getTabs();
    await this.setState({ activeTab: tabs.length - 1 });
  }


  renderTabs() {
    // Build tabs from current state - this is called on every render,
    // so tabs always have the latest data without storing in state
    const tabs = this.getTabs();
    return tabs.map((tab, index) => (
      <Tab key={tab.title} eventKey={index} title={tab.title}>
        {/* Render component; Tabs' mountOnEnter prevents repeated remounts */}
        {tab.component()}
      </Tab>
    ));
  }

  renderActionButton() {
    if (this.state.hub.userAccessLevel === 0 || this.state.siteOwnerHublevel === 0) {
      return (
        <Button className="action-button" onClick={e => this.onFollowHub(e)}>Follow  <IconContext.Provider value={{ style: { verticalAlign: '-10%',} }}><FaCheckCircle /></IconContext.Provider></Button>
      );
    }
    if (this.state.hub.userAccessLevel === hubAccessLevels.HUB_FOLLOWER || this.state.siteOwnerHublevel === hubAccessLevels.HUB_FOLLOWER) {
      return (
        <Button className="action-button-following" onClick={e => this.onUnfollowHub(e)}>Unfollow  <IconContext.Provider value={{ style: { verticalAlign: '-10%',} }}><FaCheckCircle /></IconContext.Provider></Button>
      );
    }
    if (this.state.hub.userAccessLevel === hubAccessLevels.HUB_MEMBER || this.state.siteOwnerHublevel === hubAccessLevels.HUB_MEMBER) {
      return (
        <Button className="action-button" onClick={e => this.onLeaveHub(e)}>Leave Hub</Button>
      );
    }
    if (this.state.hub.userAccessLevel === hubAccessLevels.HUB_ADMIN || this.state.siteOwnerHublevel === hubAccessLevels.HUB_ADMIN) {
      return (
        <div className="access-lvl">Hub Admin</div>
      );
    }
    if (this.state.hub.userAccessLevel === hubAccessLevels.HUB_OWNER || this.state.siteOwnerHublevel === hubAccessLevels.HUB_OWNER) {
      return (
        <div className="access-lvl">Owner</div>
      );
    }
  }

  socialMedia() {
    const { hub } = this.state;
    if (hub.twitter || hub.facebook || hub.googlePlus || hub.linkedin){
      return(
      <Col md={3} className="social-container">
        <div className="social-icons-container">
          {hub.twitter && <div onClick={() => window.open(hub.twitter)} className="social-icon-container social-tw"><i className="fa fa-twitter fa social social-tw" aria-hidden="true" /></div>}
          {hub.facebook && <div onClick={() => window.open(hub.facebook)} className="social-icon-container social-fb"><i className="fa fa-facebook fa social social-fb" aria-hidden="true" /></div>}
          {hub.googlePlus && <div onClick={() => window.open(hub.googlePlus)} className="social-icon-container social-g"><i className="fa fa-google-plus fa social social-g" aria-hidden="true" /></div>}
          {hub.linkedin && <div onClick={() => window.open(hub.linkedin)} className="social-icon-container social-ln"><i className="fa fa-linkedin fa social social-ln" aria-hidden="true" /></div>}
        </div>
      </Col>)
    }
    return;
  }

  onClickExpand1() {
    const { isExpanded1 } = this.state;
    this.setState({ isExpanded1: !isExpanded1 });
  }

  onClickExpand2() {
    const { isExpanded2 } = this.state;
    this.setState({ isExpanded2: !isExpanded2 });
  }
  onClickExpand3() {
    const { isExpanded3 } = this.state;
    this.setState({ isExpanded3: !isExpanded3 });
  }
  render() {
    const { hub } = this.state;
    const { isExpanded1, isExpanded2, isExpanded3 } = this.state;
    return this.state.notfound ? (
      <Error404 />
    ) : (
      this.state.hub && (
        <div className="hub-home-container">
          <div
            className="banner-image-container"
            style={{
              backgroundImage: `url(${config.spacesURL}/${hub.bannerId})`
            }}
          >
            {this.socialMedia()}
          </div>
          <div className="content-container">
            <Row className="header-container">
              <Row md={2} className="header-image-container">
                <div
                  className="hub-logo"
                  onClick={this.onLogoClick}
                  style={{
                    backgroundImage: `url(${config.spacesURL}/${hub.logoId})`
                  }}
                />
                {this.props.user && this.renderActionButton()}
              </Row>
              <Row md={7} className="hub-details-container">
                <h1 className="hub-name">{hub.name}</h1>
                {hub.showFollowers === 1 && (
                  <p className="followers">
                    {' '}
                    {this.state.followersCount} followers
                  </p>
                )}
                <p className="hub-description">{hub.description.replace(/\\n/g, "\n")}</p>
                { this.state.hub.show_contact_info !== 0 &&
                <div className="contact-details-container">
                  <div style={{ display: 'flex' }}>
                    <p
                      style={{
                        padding: '15px 0px 10px 0px',
                        fontWeight: 'bold'
                      }}
                    >
                      Contact Information
                    </p>
                    <Button onClick={() => this.onClickExpand1()}>
                      <IconContext.Provider
                        value={{
                          style: {
                            color: 'var(--color-background-darkest-role)',
                            size: '150px'
                          }
                        }}
                      >
                        {!isExpanded1 ? <FaCaretDown /> : <FaCaretRight />}
                      </IconContext.Provider>
                    </Button>
                  </div>
                  {!isExpanded1 && (
                    <div>
                      <div
                        className="contact"
                        style={{ borderRight: '1px solid #646464' }}
                      >
                        <div style={{ display: 'inline' }}>
                          <i
                            className="fa fa-map-marker fa social-tz"
                            aria-hidden="true"
                          />
                          <p
                            style={{
                              display: 'inline',
                              padding: '0px 10px 10px 0px'
                            }}
                          >{`${hub.address1}, ${hub.address2}, ${hub.postcode}`}</p>
                        </div>
                      </div>

                      <div
                        className="contact"
                        style={{ borderRight: '1px solid #646464' }}
                      >
                        <div style={{ display: 'inline' }}>
                          <i
                            className="fa fa-phone fa social-tz"
                            aria-hidden="true"
                          />
                          <p
                            style={{
                              display: 'inline',
                              padding: '0px 10px 10px 0px'
                            }}
                          >
                            {hub.phoneNumber}
                          </p>
                        </div>
                      </div>

                      <div className="contact">
                        <div style={{ display: 'inline' }}>
                          <i
                            className="fa fa-window-maximize fa social-tz"
                            aria-hidden="true"
                          />
                          <p
                            style={{
                              display: 'inline',
                              padding: '0px 10px 10px 0px'
                            }}
                          >
                            <a
                              rel="noopener"
                              // target="_blank"ß
                              href={
                                hub.website
                                  ? this.getHubWebsiteURL(hub.website)
                                  : ''
                              }
                              className="contact-info"
                            >
                              {hub.website}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
  }
              </Row>
            </Row>
          </div>
          <div className="tab-container">
            <Tabs
              activeKey={this.state.activeTab}
              onSelect={this.handleSelect}
                id="controlled-tab-example"
                mountOnEnter
            >
                {this.renderTabs()}
            </Tabs>
          </div>
        </div>
      )
    );
  }
}

export default checkStatus(HubHome);
